import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useStories = (categoryId) => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()

  const getStories = async (categoryId) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      `${
        loggedIn ? env.apiUrl : env.publicApiUrl
      }/categories/${categoryId}/stories`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['stories', categoryId],
    queryFn: () => getStories(categoryId),
    enabled: !!categoryId
  })

  useEffect(() => {
    if (query.isLoading) {
      progressStart()
    } else if (query.isSuccess) {
      progressEnd()
    } else if (query.isError) {
      handleError(query.error, 'Error getting stories')
      progressEnd()
    }
  }, [
    query.isLoading,
    query.isSuccess,
    query.isError,
    query.error,
    progressStart,
    progressEnd,
    handleError
  ])

  return {
    stories: query.data
  }
}

export { useStories }
